export default function fromPairs(pairs: ReadonlyArray<readonly any[]>): Record<PropertyKey, any> {
  const result: Record<PropertyKey, any> = {};
  for (const [key, value] of pairs) {
    result[key] = value;
  }
  return result;
}
